/**
 * Parse blood summary header dates (EU-style dd/mm/yyyy from API mapping,
 * also yyyy/mm/dd and separators . -).
 * @param {string} s
 * @returns {number} epoch ms, or 0 if invalid/empty
 */
export function parseBloodTestHeaderDate(s) {
  const raw = String(s || '').trim();
  if (!raw) return 0;
  const norm = raw.replaceAll('.', '/').replaceAll('-', '/');
  const parts = norm.split('/');
  if (parts.length !== 3) return 0;
  const [p1, p2, p3] = parts.map((p) => p.trim());
  let day;
  let month;
  let year;
  if (p1.length === 4) {
    year = parseInt(p1, 10);
    month = parseInt(p2, 10);
    day = parseInt(p3, 10);
  } else {
    day = parseInt(p1, 10);
    month = parseInt(p2, 10);
    year = parseInt(p3, 10);
    if (p3.length === 2) year = 2000 + year; // assume 20xx for 2-digit years
  }
  if (
    !Number.isFinite(day) ||
    !Number.isFinite(month) ||
    !Number.isFinite(year)
  )
    return 0;
  if (month < 1 || month > 12 || day < 1 || day > 31) return 0;
  const t = new Date(year, month - 1, day).getTime();
  return Number.isFinite(t) ? t : 0;
}

/**
 * Sort comparator: newest result date first; tie-break by newest test date.
 */
export function compareBloodTestsByResultThenTestDate(a, b) {
  const rdA = parseBloodTestHeaderDate(a?.header?.resultDate);
  const rdB = parseBloodTestHeaderDate(b?.header?.resultDate);
  if (rdA !== rdB) return rdB - rdA;
  const tdA = parseBloodTestHeaderDate(a?.header?.testDate);
  const tdB = parseBloodTestHeaderDate(b?.header?.testDate);
  return tdB - tdA;
}
